
const LpTokenImg = (
    { fromTokenLogo, toTokenLogo, className }: { fromTokenLogo: string; toTokenLogo: string, className?: string }
) => {
    return (
        <div className='relative'>
            <img className={`${className}`} src={fromTokenLogo} alt="" />
            <img className={`${className} absolute right-0 top-0 translate-x-1/2`} src={toTokenLogo} alt="" />
        </div>
    )
}

export default LpTokenImg